module.exports = __webpack_public_path__ + "docs/t&c-China.4f275ee3f4268cd88f4f4bf8b4ef3517.html";